<template>
  <div
    v-tooltip="`${$t('COMMON.NEW')} ${$t('COMMON.TASK')}`"
    data-cy="task-link"
    class="modal-icon"
    @click="emit('modal:show', $event, CommunicationType.task)"
  >
    <div class="flex h-full items-center justify-center">
      <icon-base :icon="IconNotes" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CommunicationType } from "@/enums/communicationLogs";

import IconNotes from "@/components/icons/IconNotes.vue";

const emit = defineEmits<{
  "modal:show": [MouseEvent, CommunicationType];
}>();
</script>
